<template>
  <div class='row-submittedorder'>
    <LeftListMember :pos="7"></LeftListMember>
    <div class="g-row2">
      <div class="m-hone1 m-submittedorder ">
        <ul class="g-tablist1">
          <li class="li " :class="navIndex == 0 ? 'activite' : ''" @click="checkIndex(0)">
            <div class="txt">全部订单</div>
          </li>
          <li class="li" :class="navIndex == 1 ? 'activite' : ''" @click="checkIndex(1)">
            <div class="txt">已下单</div>
          </li>
          <li class="li" :class="navIndex == 2 ? 'activite' : ''" @click="checkIndex(2)">
            <div class="txt">已取消</div>
          </li>
        </ul>

        <div class="m-searchnew">
          <div class="form">
            <div class="left-tit">按条件查询：</div>
            <div class="right-inp">
              <div class="inp">
                <el-input v-model="search.orderNo" type="text" name="" id="" placeholder="请输入订单号" />
              </div>
              <div class="inp">
                <el-input v-model="search.title" type="text" name="" id="" placeholder="请输入订单名称" />
              </div>
              <div class="inp">
                <el-input v-model="search.supplier" type="text" name="" id="" placeholder="请输入供应商名称" />
              </div>
            </div>
            <button class="btn" @click="loadOrder(1)"><img src="@/assets/images/index/icon6.png" class="icon" alt="" style="max-height: 60%;" /></button>
          </div>
        </div>

        <div class="contect g-contecte3">
          <div class="g-tite2">{{ base.navList[navIndex] }}</div>
          <div class="box">
            <div class="item item1">
              <div class="conl">
                <span class=" nian"><a-dropdown>
                    <a class="ant-dropdown-link" @click="e => e.preventDefault()">
                      <em>{{ search.year ? search.year+'年' : '全部' }}订单</em> <a-icon type="down" />
                    </a>
                    <a-menu slot="overlay" @click="({item,key})=>search.year=key">
                      <a-menu-item v-for="year in base.yearList" :key="year">
                        <a href="javascript:;">{{year}}年订单</a>
                      </a-menu-item>
                    </a-menu>
                  </a-dropdown>
                </span>
<!--                <span class=" nian"><a-dropdown>-->
<!--                    <a class="ant-dropdown-link" @click="e => e.preventDefault()">-->
<!--                      <em>今年订单</em> <a-icon type="down" />-->
<!--                    </a>-->
<!--                    <a-menu slot="overlay">-->
<!--                      <a-menu-item>-->
<!--                        <a href="javascript:;">2024年订单</a>-->
<!--                      </a-menu-item>-->
<!--                      <a-menu-item>-->
<!--                        <a href="javascript:;">2025年订单</a>-->
<!--                      </a-menu-item>-->
<!--                      <a-menu-item>-->
<!--                        <a href="javascript:;">2025年订单</a>-->
<!--                      </a-menu-item>-->
<!--                    </a-menu>-->
<!--                  </a-dropdown></span>-->
              </div>
              <div class="conr">
                <span class="span1">状态</span>
                <span class="span1">订单详细</span>
                <span class="span1">操作</span>
              </div>
            </div>
            <div v-for="order in data" :key="order.id" class="box2 g-submittedordere1 g-submittedordere3 g-memberordere1">
              <div class="item item2">
                <div class="conl">
                  <span class="span1">{{ (order.createtime||'').split(' ')[0] }}</span>
                  <span class="span1">{{ (order.createtime||' ').split(' ')[1] }}</span>
                </div>
                <div class="conr">
                  <a href="javascript:;" v-if="order.status==0" style="color: #1690FF;" @click="resumeOrder(order)">恢复订单</a>
                  <a href="javascript:;" v-if="order.status==0" style="margin-left: 10px;" @click="delOrder(order)">删除订单</a>
                  <a href="javascript:;" v-if="order.status==1" @click="cancelOrder(order)">取消订单</a>
                </div>
              </div>
              <div class="item item1 item3" style="background-color: transparent">
                <div class="conl">
                  <span class=" nian">订单号： {{ order.orderNo }} </span>
                  <span class="name"><em> <span v-if="order.supplierInfoList.length">供应商:{{ order.supplierInfoList[0].shortName || order.supplierInfoList[0].companyName }}</span></em></span>
                  <span class="name">订单名称：{{ order.title || '' }}</span>
                </div>
                <div class="conr">
                  <span class="span1" style="color: #999999;">{{ order.statusOptionName }}</span>
                  <div class="span1" style="color: #1E2127;" :class="{ Visible: detailId === order.id }" @click="toggleIf(order)">
                    <i class="el-icon el-icon-loading" v-if="detailId === order.id && detailLoading"></i>
                    查看详细
                    <img src="@/assets/images/e-arr3.png" class="look" alt="" />
                    <img src="@/assets/images/e-arr3-on.png"
                      class="look look2" alt="" />
                  </div>
                  <div class="ftit cz buttonlist span1 " style="display: flex;justify-content: space-around;width: 100%;">
                    <a href="javascript:;" class="load" :class="{on: order.status==1}" @click="exportOrder(order)">
                      <div class="pic"><img src="@/assets/images/e-load4.png" class="img" alt="" /><img
                          src="@/assets/images/e-load5.png" class="img2" alt="" /></div>导出订单
                    </a>
                    <a href="javascript:;" class="load" :class="{on: order.status==1}" @click="downloadOrder(order)" style="width: 1.8rem;">
                      <div class="pic"><img src="@/assets/images/e-load4.png" class="img" alt="" /><img
                          src="@/assets/images/e-load5.png" class="img2" alt="" /></div>MARC数据下载
                    </a>
                  </div>
                </div>
              </div>
              <div class="m-table" v-if="detailId === order.id">
                <a-table :columns="columns" :data-source="detailData" :pagination="false" :bordered="false"
                :scroll="{ x: 700 }">
                  <div slot="supplier" slot-scope="supplier, record, indent, expanded">
                    <a @click="openSupplier(record.supplierUid)" class="supplier" >{{ record.supplier }}</a>
                  </div>
                </a-table>
              </div>
            </div>
          </div>
          <mPages :page.sync="filter.page" :page-size.sync="filter.pageSize" :total="dataCount" />
        </div>

      </div>
    </div>
  </div>
</template>

<script>
import LeftListMember from "@/components/LeftListMember";
import mPages from '@/components/mpages/mPages.vue'
import {getApiRes, sleep} from "@/api/apiUtil";
import apiUserInfo from "@/api/userInfo";
import apiBkBookCart from "@/api/bkBookCart";
import apiBkBookOrder from "@/api/bkBookOrder";
import apiBkDownloadTask from "@/api/bkDownloadTask";
export default {
  components: {
    LeftListMember,
    mPages,
  },
  data() {
    return {
      // 折叠
      isVisible: false,
      navIndex: 0,
      // 表单
      labelCol: { span: 4 },
      wrapperCol: { span: 14 },
      form: {
        name: '',
        name2: '',
        name3: '',
        name4: '',
        region: undefined,
        region2: undefined,
      },
      // 表格
      // selectedRowKeys: [], // Check here to configure the default column
      columns: [
        {
          title: "ISBN",
          dataIndex: "isbn",
          key: "isbn",
          width: '10.1%',

        },
        {
          title: "书名",
          dataIndex: "name",
          key: "name",
          width: '12.8%',
          ellipsis: true,
        },
        {
          title: "出版社",
          dataIndex: "publisher",
          key: "publisher",
          width: '9.5%',
          ellipsis: true,
        },
        {
          title: "作者",
          dataIndex: "author",
          key: "author",
          ellipsis: true,
          width: '5.9%',
        },

        {
          title: "发行时间",
          dataIndex: "publishDate",
          key: "publishDate",
          ellipsis: true,
          width: '7.4%',
        },

        // {
        //   title: "印刷日期",
        //   dataIndex: "printDate",
        //   key: "printDate",
        //   ellipsis: true,
        //   width: '7.4%',
        // },
        {
          title: "开本",
          dataIndex: "pageSize",
          key: "pageSize",
          ellipsis: true,
          width: '4.9%',
        },
        {
          title: "定价",
          dataIndex: "price",
          key: "price",
          ellipsis: true,
          width: '4.9%',
        },
        {
          title: "折扣",
          dataIndex: "discount",
          key: "discount",
          ellipsis: true,
          width: '5.4%',
        },
        // {
        //   title: "供应商",
        //   dataIndex: "supplier",
        //   key: "supplier",
        //   ellipsis: true,
        //   width: '21.6%',
        //   scopedSlots: { customRender: 'supplier' },
        // },
        {
          title: "订单数",
          dataIndex: "num",
          key: "num",
          ellipsis: true,
          width: '11.1%',
        },


      ],

      base: {
        navList: ['全部订单','已下单','已取消'],
        yearList: [],
      },
      data: [],
      dataCount: 0,
      detailId: 0,
      detailData: [],
      detailLoading: false,
      search: {
        status: undefined,
        year: undefined,
        orderNo: '',
        title: '',
        supplier: ''
      },
      filter: {
        page: 1,
        pageSize: 20,
      },

    };
  },
  computed: {},
  watch: {
    filter:{
      handler() {
        this.loadOrder()
      },
      deep: true
    },
    search:{
      handler() {
        this.loadOrder(1)
      },
      deep: true
    },
  },
  mounted() {
    this.initYears()
    this.loadOrder()

    // 检测认证
    if(this.$store.state.user.userInfo.type != 2 && this.$store.state.user.company.status != 2) { //会员和供应商需要认证
      return this.$alert('请先完成资质认证', '提示', {callback:()=>this.$router.push(this.$store.state.user.userInfo.type == 1 ? '/info-qualifications' : '/center-qualifications')})
    }
  },
  methods: {
    async exportOrder(order){
      if(order.status!=1) return this.$message.error('已取消订单无法导出')
      window.open(process.env.VUE_APP_BASE_URL + `home/bk_book_order/customerExport?id=${order.id}`, '_blank')
    },
    async downloadOrder(order){
      if(order.status!=1) return this.$message.error('已取消订单无法下载')
      let re = await getApiRes(apiBkDownloadTask.createFromOrder(order.id), 0, 1)
      if(re.code!=0) return;
      await sleep(1500)
      this.$message.success('下载任务创建成功')
      this.$router.push('/member-task-center')
    },
    async cancelOrder(order){
      let reConfirm = await this.$confirm('确定要取消单吗?').catch((e)=>false)
      if(!reConfirm) return
      const re = await getApiRes(apiBkBookOrder.cancel(order.id),0,1,1,1)
      this.loadOrder(1)
    },
    async resumeOrder(order){
      let reConfirm = await this.$confirm('确定要恢复订单吗?').catch((e)=>false)
      if(!reConfirm) return
      const re = await getApiRes(apiBkBookOrder.resume(order.id),0,1,1,1)
      this.loadOrder(1)
    },
    async delOrder(order){
      let reConfirm = await this.$confirm('确定要删除订单吗?').catch((e)=>false)
      if(!reConfirm) return
      const re = await getApiRes(apiBkBookOrder.del(order.id),0,1,1,1)
      this.loadOrder(1)
    },
    async loadOrder(page = undefined){
      if(page) this.filter.page = page
      let map = await this.getMap()
      let re = await getApiRes(apiBkBookOrder.getList(undefined,undefined,map,'',[],this.filter), 0, 1,1)
      this.data = re.data
      this.dataCount = re.count
      this.detailData = []
      this.detailId = 0
    },
    async loadDetail(id){
      let map = await this.getMap()
      map.push(['id','=',id])
      let extra = {isCustomerDetail: 1, ...this.filter}
      let re = await getApiRes(apiBkBookOrder.getList(undefined,undefined,map,'',[],extra), 0, 1,1)
      if(re.code==0 && re.data && re.data.length>0) {
        this.detailData = re.data[0].customerDetailList || []
      }
    },
    async getMap(){
      let map = [['pid','>',0]] //只加载子订单
      if(this.search.status!== undefined) map.push(['status','=', this.search.status])
      if(this.search.year !== undefined) {
        map.push(['createtime', '>', new Date(`${this.search.year}-01-01`).getTime()/1000 - 1])
        map.push(['createtime', '<', new Date(`${this.search.year+1}-01-01`).getTime()/1000])
      }
      if(this.search.orderNo) map.push(['orderNo','like', '%'+this.search.orderNo+'%'])
      if(this.search.title) map.push(['title','like', '%'+this.search.title+'%'])
      // 搜索供应商
      if(this.search.supplier){
        let re = await getApiRes(apiUserInfo.search(this.search.supplier, 1, 10))
        if(re.code==0){
          let uids = []
          re.data.forEach(v=>{
            if(v.userInfo.type==1) uids.push(v.userInfo.uid)
          })
          map.push(['supplierUids','like', '%,'+uids.join(',')+',%'])
        }
      }
      return map
    },
    async openSupplier(uid){
      let re = await getApiRes(apiUserInfo.GetShowIdByUid(uid),0,1,1,0)
      if(re.code==0 && re.data){
        window.open('/home/user_info/home?id='+re.data, '_blank')
      }
    },
    initYears(){
      for(let y=2024; y<=(new Date()).getFullYear(); y++){
        this.base.yearList.push(y)
      }
    },
    checkIndex(index) {
      console.log(index)
      this.navIndex = index;
      switch (index){
        case 0: this.search.status = undefined; break;
        case 1: this.search.status = 1; break;
        case 2: this.search.status = 0; break;
      }
    },
    // 折叠
    async toggleIf(order) {
      if(this.detailId === order.id){
        this.detailId = 0
        return
      }
      this.detailLoading = true
      await this.loadDetail(order.id)
      this.detailLoading = false
      // this.isVisible = !this.isVisible;
      this.detailId = order.id
    },
    // 类名end
    // 表格
    // 搜索
    onSearch(value) {
      console.log(value);
    },
    onSubmit() {
      console.log('submit!', this.form);
    },
    // 表格
    // onSelectChange(selectedRowKeys) {
    //   console.log('selectedRowKeys changed: ', selectedRowKeys);
    //   this.selectedRowKeys = selectedRowKeys;
    // },

  },
};

</script>

<style lang="scss" scoped>
.ant-input-affix-wrapper .ant-input-suffix {
  right: 0;
}
</style>
